import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField
} from "@mui/material";
import React, { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PaymentOptions } from "../../components/Accounts/Account/Utlis";
import Report from "../../components/Accounts/Reports/report";
import { Level3AutoComplete } from "../../components/AutoComplete/Level3";
import { VoucherItem, VoucherItemType, VoucherType, createAccountVoucher } from "../../utils/vouchers/vouchersHelper";

export const PaymentModal = ({ open, onClose }) => {
  const [values, setValues] = useState({});
  const [head, setHead] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [voucherPrintData, setVoucherPrintData] = useState({});
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [openNew, setOpenNew] = useState(false);
  const handleOpen = () => setOpenNew(true);

  const handleClose = () => {
    setVoucherPrintData({});
    setOpenNew(false);
  };
  const handleSubmit = async () => {
    if (parseFloat(values.amountPaid + "") <= 0) {
      alert("Please enter valid data");
      return;
    }

    setDetailsModalOpen(true);
    onClose(); // Close the payment modal

    let level3Code = head.fullcode;

    try {
      let type = paymentMode.value === PaymentOptions.Cash
        ? VoucherType.cashPayment
        : VoucherType.bankPayment;

      await createAccountVoucher(type, [
        new VoucherItem({
          transaction: VoucherItemType.debit,
          amount: values.amountPaid,
          code: level3Code,
          particular: head.name,
          description: values.description,
          type,
        }),
        new VoucherItem({
          transaction: VoucherItemType.credit,
          amount: values.amountPaid,
          code: paymentMode.value === PaymentOptions.Cash ? "07-001-0001" : "07-002-0001",
          particular: paymentMode.value === PaymentOptions.Cash ? "Cash Payment" : "Bank Payment",
          description: values.description,
          type,
        }),
      ]);

      toast.success("Successfully added new item!", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      // dispatch(updatePayable({ id: selectedSupplier.value, newPayable }));

      // Prepare bill details and open details modal
      const date = new Date();
      // for voucher //
      let voucherObject = {
        id: "617fb229f661460020535df3",
        invoice: [
          {
            transaction: VoucherItemType.credit,
            debit: "",
            credit: values.amountPaid,
            amount: values.amountPaid,
            code:
            paymentMode.value === PaymentOptions.Cash
                ? "07-001-0001"
                : "07-002-0001",
            particular:
            paymentMode.value === PaymentOptions.Cash
                ? "Cash Payment"
                : "Bank Payment",
            Discription: "bill paid to supplier",
            cheque: "",
            billno: "",
            transactionType: VoucherItemType.credit,
            type: type,
            id: "1",
            site: "1",
            voucherDate: new Date().toLocaleDateString(),
            voucherUTCDate: {
              _seconds: 1729517393,
              _nanoseconds: 976000000,
            },
            voucherNumber: 33,
          },
          {
            transaction: VoucherItemType.debit,
            debit: values.amountPaid,
            credit: "",
            amount: values.amountPaid + "",
            code: level3Code,
            particular:head.name,
            description: values.description,
            Discription: values.description,
            cheque: "",
            billno: "",
            transactionType: VoucherItemType.debit,
            type: type,
            id: "1",
            site: "1",
            voucherDate: new Date().toLocaleDateString(),
            voucherUTCDate: {
              _seconds: 1729517393,
              _nanoseconds: 975000000,
            },
            voucherNumber: 33,
          },
        ],
        titleData: {
          site: "New Site",
          title: "Voucher",
          subTitle: "Date: " + new Date().toLocaleDateString(),
          leftTitle: "",
          leftSubTitle: "",
          rightTitle: "",
          rightSubTitle: "",
        },
        subTitleData: {
          type: type,
          number: 33,
          description:  values.description,
        },
        docTitle: "",
        docType: "Voucher",
        from: "",
        to: "",
        codeDetails: {},
        totalDebit: values.amountPaid,
        totalCredit: values.amountPaid,
        balance: 0,
        openingBalance: 0,
      };
      setVoucherPrintData(voucherObject);
      handleOpen();
    } catch (error) {
      console.log(error);
      toast.error("Failed to update payment!", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const handleHeadChange = (e, newValue) => {
    setHead(newValue);
    setValues({}); // Clear form values when head changes
  };

  const paymentModeOptions = Object.keys(PaymentOptions).map((key) => ({
    value: PaymentOptions[key],
    label: key,
  }));

  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle textAlign="center">Create Payment</DialogTitle>
        <DialogContent>
          <form onSubmit={(e) => e.preventDefault()}>
            <Stack
              sx={{
                width: "100%",
                minWidth: { xs: "350px", sm: "500px", md: "400px" },
                gap: "1.5rem",
              }}
            >
              <Box>
                <Level3AutoComplete
                  value={head}
                  onChange={handleHeadChange}
                />
              </Box>
              <Box>
                <TextField
                  label="Payment"
                  type="number"
                  sx={{ minWidth: "100%" }}
                  value={values.amountPaid || ""}
                  onChange={(e) =>
                    setValues({ ...values, amountPaid: e.target.value })
                  }
                />
              </Box>
              <Box>
                <TextField
                  label="Description"
                  type="text"
                  sx={{ minWidth: "100%" }}
                  value={values.description || ""}
                  onChange={(e) =>
                    setValues({ ...values, description: e.target.value })
                  }
                />
              </Box>
              <Box>
                <label>Payment Mode</label>
                <Autocomplete
                  disablePortal
                  id="payment-mode-autocomplete"
                  options={paymentModeOptions}
                  sx={{
                    minWidth: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  renderInput={(params) => <TextField {...params} />}
                  value={paymentMode}
                  onChange={(event, newValue) => setPaymentMode(newValue)}
                />
              </Box>
            </Stack>
          </form>
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button color="secondary" onClick={handleSubmit} variant="contained">
            Create
          </Button>
        </DialogActions>
      </Dialog>

      {/* {detailsModalOpen && (
        <Dialog open={detailsModalOpen} onClose={() => setDetailsModalOpen(false)}>
          <DialogTitle textAlign="center">Payment Details</DialogTitle>
          <DialogContent>
            <TableContainer>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell style={{ direction: "rtl" }}>نام:</TableCell>
                    <TableCell>{head.name}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ direction: "rtl" }}>ادائیگی کی رقم:</TableCell>
                    <TableCell>{values.amountPaid}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ direction: "rtl" }}>تفصیل:</TableCell>
                    <TableCell>{values.description}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ direction: "rtl" }}>ادائیگی کا طریقہ:</TableCell>
                    <TableCell>{paymentMode.label}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDetailsModalOpen(false)} variant="contained">Close</Button>
          </DialogActions>
        </Dialog>
      )} */}
      <Report
        open={openNew}
        handleClose={handleClose}
        data={voucherPrintData}
      />
    </>
  );
};
